import { SearchIcon, X } from "lucide-react";
import { useId } from "react";

import { Input } from "@/components/ui/v2/input";
import { Label } from "@/components/ui/v2/label";

export type SearchInputProps = React.ComponentProps<typeof Input> & {
  label?: string;
};
export default function Component(props: SearchInputProps) {
  const id = useId();
  return (
    <div className="*:not-first:mt-2">
      {props.label && <Label htmlFor={id}>{props.label}</Label>}
      <div className="relative">
        <Input
          id={id}
          className="peer ps-9 pe-9"
          placeholder={props.placeholder}
          type="text"
          role="search"
          value={props.value}
          onChange={(e) => {
            props.onChange?.(e);
          }}
        />
        <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-muted-foreground/80 peer-disabled:opacity-50">
          <SearchIcon size={16} aria-hidden="true" />
        </div>
        {props.value && (
          <button
            type="button"
            onClick={() => {
              props.onChange?.({
                target: { value: "" },
              } as React.ChangeEvent<HTMLInputElement>);
            }}
            className="absolute inset-y-0 end-0 flex items-center justify-center pe-3 text-muted-foreground/80 hover:text-foreground transition-colors peer-disabled:opacity-50 cursor-pointer"
            aria-label="Clear search"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
